import { h } from "./../../utils/createElement";
import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { emptyFn } from '../../utils/helper';
import { consumeTheme } from '../../utils/theme';
var Dragger = (function (_super) {
    __extends(Dragger, _super);
    function Dragger() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ref = null;
        _this.minLeft = 0;
        _this.minTop = 0;
        _this.setRef = function (ref) {
            _this.ref = ref;
        };
        _this.onMouseDown = function (e) {
            var _a, _b;
            (_b = (_a = _this.props).onMouseDown) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            if (!_this.props.draggable || !_this.ref || _this.isFromInnerInput(e)) {
                return;
            }
            _this.mouse = true;
            var _c = _this.ref.getBoundingClientRect(), left = _c.left, top = _c.top, width = _c.width, height = _c.height;
            var clientX = e.clientX, clientY = e.clientY;
            _this.startLeft = left;
            _this.startTop = top;
            _this.startX = clientX;
            _this.startY = clientY;
            _this.maxLeft = window.innerWidth - width;
            _this.maxTop = window.innerHeight - height;
            _this.ref.style.userSelect = 'none';
            _this.ref.parentElement.style.pointerEvents = 'auto';
        };
        _this.onMouseMove = function (e) {
            if (!_this.mouse || !_this.ref) {
                return;
            }
            var clientX = e.clientX, clientY = e.clientY;
            var left = _this.startLeft + clientX - _this.startX;
            var top = _this.startTop + clientY - _this.startY;
            left = Math.min(Math.max(_this.minLeft, left), _this.maxLeft);
            top = Math.min(Math.max(_this.minTop, top), _this.maxTop);
            _this.ref.style.position = 'absolute';
            _this.ref.style.left = left + "px";
            _this.ref.style.top = top + "px";
        };
        _this.onMouseUp = function (e) {
            if (!_this.ref) {
                return;
            }
            _this.mouse = false;
            _this.ref.style.userSelect = 'auto';
            _this.ref.parentElement.style.pointerEvents = '';
            var _a = _this.props, onDragEnd = _a.onDragEnd, draggable = _a.draggable;
            if (draggable === true) {
                onDragEnd(e);
            }
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, children = _a.children, className = _a.className, prefixCls = _a.prefixCls, style = _a.style, onDragEnd = _a.onDragEnd, draggable = _a.draggable, rest = __rest(_a, ["children", "className", "prefixCls", "style", "onDragEnd", "draggable"]);
            var cls = classNames(prefixCls, className);
            return (h("div", __assign({}, rest, { className: cls, style: style, ref: _this.setRef, onMouseDown: _this.onMouseDown, tabIndex: -1 }), children));
        };
        return _this;
    }
    Dragger.prototype.componentDidMount = function () {
        document.body.addEventListener('mousemove', this.onMouseMove);
        document.body.addEventListener('mouseup', this.onMouseUp);
    };
    Dragger.prototype.componentWillUnmount = function () {
        document.body.removeEventListener('mousemove', this.onMouseMove);
        document.body.removeEventListener('mouseup', this.onMouseUp);
    };
    Dragger.prototype.isFromInnerInput = function (e) {
        var _a;
        var target = e.target;
        return Boolean(/input|textarea/i.test(target.tagName)
            && ((_a = this.ref) === null || _a === void 0 ? void 0 : _a.contains(target)));
    };
    Dragger.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Dragger;
}(React.Component));
export default Dragger;
Dragger.defaultProps = {
    prefixCls: 'dui-dragger',
    onDragEnd: emptyFn,
    onClick: emptyFn,
    draggable: false
};
